// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9c17c44a","977":"0e22a4ed"}[chunkId] + ".chunk.js";
};